import type { FC } from 'react';
import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import { ModalNamesEnum } from '@shared/enums/modalNames.enum';
import { ProfileViewDataEnum } from '@shared/enums/profileViewData.enum';
import useAnalyticsEventTracker from '@shared/hooks/analytics/useAnalyticsEventTracker';
import { useAppDispatch } from '@shared/hooks/redux';
import modalObserver from '@shared/utils/observers/modalObserver';
import { setViewDataItem } from '@store/Profile/profile.actions';
type SkipBlockProps = {
  closeCallback: () => void;
};
export const SkipBlock: FC<SkipBlockProps> = ({ closeCallback }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const gaEventTracker = useAnalyticsEventTracker();

  const handleSkipOnboarding = () => {
    modalObserver.addModal(ModalNamesEnum.alertModal, {
      props: {
        modalContent: {
          header: t('onboardingSetup.skipOnboarding.header'),
          title: t('onboardingSetup.skipOnboarding.title'),
          subtitle: t('onboardingSetup.skipOnboarding.subtitle'),
          variantIcon: 'done',
          isSpaceBetweenBtn: true,
        },
        rightBtnProps: {
          isShow: true,
          label: t('general.buttons.continueChecklist'),
          color: 'primary',
          isLoadingBtn: false,
          onClick: () => {
            modalObserver.removeModal(ModalNamesEnum.alertModal);
          },
        },

        leftBtnProps: {
          label: 'Skip',
          isShow: true,
          variant: 'text',
          size: 'small',
          color: 'secondary',
          onClick: () => {
            dispatch(setViewDataItem({ entity: ProfileViewDataEnum.is_view_skip_onboarding }));
            modalObserver.removeModal(ModalNamesEnum.alertModal);
            closeCallback();
            gaEventTracker({
              event: AnalyticsEventEnum.onboardingChecklistSkipped,
            });
          },
        },
      },
    });
  };

  return (
    <Box mt={'4px'} display="flex" alignItems="center" width="100%" height="100%" justifyContent="center">
      <Typography
        sx={{
          '&:hover': {
            opacity: 0.7,
            transition: 'all 0.3s ease',
          },
          cursor: 'pointer',
        }}
        color={(theme) => theme.palette.case.neutral.n500}
        variant="t12r"
        onClick={handleSkipOnboarding}
      >
        Skip this checklist
      </Typography>
    </Box>
  );
};
